export default __webpack_public_path__ + "static/media/drums.bde58933.mid";